import React, { useContext, useRef } from "react";
import AuthContext from "../../../context/auth/authContext";
import Alert from "../../layouts/Alert";
import "../../../styles/fonts.css";
const ResetPass = () => {
  const authContext = useContext(AuthContext);
  const email = useRef("");
  const { resetPassword } = authContext;
  const resetPass = () => {
    resetPassword(email.current.value);
  };

  return (
    <div>
      <h1 class='mb-4 upperfont'>Re Enter Your Password</h1>
      <hr></hr>
      <Alert />

      <form>
        <input ref={email} className='form-control simplefont' name='email' type='text' />
      <button type='button' class='btn btn-primary btn-block slantfont my-4' onClick={resetPass}>
        Reset
      </button>
      </form>
    </div>
  );
};

export default ResetPass;
